import EnumsManager from 'utils/EnumsManager';
import {
  SETUP_WORKFLOW,
  UPDATE_WORKFLOW_STATUS,
  SETUP_WORKFLOW_PAGENATION,
  SETUP_WORKFLOW_ACTION_LOG,
  SETUP_WORKFLOW_ACTION_PAGENATION,
  SETUP_WORKFLOW_FAILURE_LOG,
  SETUP_WORKFLOW_FAILURE_PAGENATION
} from './actionType';

const initialWorkflowList = {
  workflows: [],
  workflowTablePagination: {
    perPage: EnumsManager.DefaultPageConfigs.PageSize,
    currentPage: 1,
    total: 0,
  }
};

const updatedStatusWorkflows = (workflows, payload) => {
  const { id, is_active } = payload;
  const updatedWorkflows = workflows.map(item => {
    if (item.id === id) {
      return { ...item, is_active };
    }
    return item;
  });
  return updatedWorkflows;
};

export const workflowList = (state = initialWorkflowList, action) => {
  const { type, payload } = action;
  switch (type) {
    case SETUP_WORKFLOW:
      const { workflows } = payload;
      return {
        ...state,
        workflows
      };
    case UPDATE_WORKFLOW_STATUS:
      return {
        ...state,
        workflows: updatedStatusWorkflows(state.workflows, payload)
      };
    case SETUP_WORKFLOW_PAGENATION:
      const { perPage, currentPage, total } = payload;
      return {
        ...state,
        workflowTablePagination: {
          ...state.workflowTablePagination,
          perPage,
          currentPage,
          total
        }
      };
    default:
      return state;
  }
};

const initialWorkflowLog = {
  actionLogs: [],
  actionLogsPagination: {
    perPage: EnumsManager.DefaultPageConfigs.PageSize,
    currentPage: 1,
    total: 0,
  },
  failureLogs: [],
  failureLogsPagination: {
    perPage: EnumsManager.DefaultPageConfigs.PageSize,
    currentPage: 1,
    total: 0,
  },
};

export const workflowLogs = (state = initialWorkflowLog, action) => {
  const { type, payload } = action;
  switch (type) {
    case SETUP_WORKFLOW_ACTION_LOG:
      const { actionLogs } = payload;
      return {
        ...state,
        actionLogs
      };
    case SETUP_WORKFLOW_ACTION_PAGENATION:
      return {
        ...state,
        actionLogsPagination: {
          ...state.actionLogsPagination,
          perPage: payload.perPage,
          currentPage: payload.currentPage,
          total: payload.total
        }
      };
    case SETUP_WORKFLOW_FAILURE_LOG:
      const { failureLogs } = payload;
      return {
        ...state,
        failureLogs
      };
    case SETUP_WORKFLOW_FAILURE_PAGENATION:
      return {
        ...state,
        failureLogsPagination: {
          ...state.failureLogsPagination,
          perPage: payload.perPage,
          currentPage: payload.currentPage,
          total: payload.total
        }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/views/Setup/WorkflowList/flow/reducer.js